enum DashboardCardDisplayType {
    PERCENT = 'Percent',
    NUMBER = 'Number',
    FREQUENCY = 'Frequency',
    THUMBUPDOWN = 'Thumbupdown',
    MONEY = 'Money',
}

export default DashboardCardDisplayType;
